<script>
/* eslint-disable */
import AtTextarea from 'vue-at/src/AtTextarea.vue'
import { getAtAndIndex } from 'vue-at/src/util.js'
import getCaretCoordinates from 'textarea-caret'

export default {
  extends: AtTextarea,
  name: 'CustomAtTextarea',
  computed: {
    style () {
      if (this.atwho) {
        const { x, y } = this.atwho
        const { wrap } = this.$refs
        const el = this.$el.querySelector('input')
        if (wrap) {
          const left = x + el.offsetLeft - el.scrollLeft + 'px'
          const top = y + el.offsetTop + el.scrollTop + 'px'
          return { left, top }
        }
      }
      return null
    },
  },
  methods: {
    dispatchInput () {
      let el = this.$el.querySelector('input')
      let ev = new Event('input', { bubbles: true })
      el.dispatchEvent(ev)
    },
    handleInput (keep) {
      if (this.hasComposition) return
      const el = this.$el.querySelector('#search__input__field')
      this.$emit('input', el.value)
      const text = el.value.slice(0, el.selectionEnd)
      if (text) {
        const { atItems, allowSpaces } = this
        let show = true
        const { at, index } = getAtAndIndex(text, atItems)
        if (index < 0) show = false

        // authorise de commencer par un hashtag
        const prev = text[index - 1]
        if (prev && !/[^\w/]/.test(prev)) show = false

        const chunk = text.slice(index + at.length, text.length)

        if (!allowSpaces && /\s/.test(chunk)) {
          show = false
        }
        // chunk以空白字符开头不匹配 避免`@ `也匹配
        if (/^\s/.test(chunk)) show = false

        if (!show) {
          this.closePanel()
        } else {
          // if (!keep) { // fixme: should be consistent with At.vue
          //   this.$emit('at', chunk)
          // }
          if (chunk.length > 1) {
            this.$axios.post('autocomplete/', { q: chunk })
                .then(response => {
                  const matched = response.data.suggest.tagSuggest[0].options.map(r => r.text)
                  if (matched.length) {
                    this.openPanel(matched, chunk, index, at, keep)
                  } else {
                    this.closePanel()
                  }
                })
          } else {
            this.closePanel()
          }
        }
      } else {
        this.closePanel()
      }
    },
    handleDelete () {
      const el = this.$el.querySelector('input')
      const text = el.value.slice(0, el.selectionEnd)
      if (text) {
        const { atItems, members, suffix, deleteMatch, itemName } = this
        const { at, index } = getAtAndIndex(text, atItems)
        if (index > -1) {
          const chunk = text.slice(index + at.length)
          const has = members.some(v => {
            const name = itemName(v)
            return deleteMatch(name, chunk, suffix)
          })
          if (has) {
            el.value = el.value.slice(0, index) +
              el.value.slice(el.selectionEnd - 1)
            el.selectionStart = index + 1
            el.selectionEnd = index + 1
            this.handleInput()
          }
        }
      }
    },
    handleKeyDown (e) {
      const { atwho } = this
      if (atwho) {
        if (e.keyCode === 38 || e.keyCode === 40) { // ↑/↓
          if (!(e.metaKey || e.ctrlKey)) {
            e.preventDefault()
            e.stopPropagation()
            this.selectByKeyboard(e)
          }
          return
        }
        if (e.keyCode === 13 || (this.tabSelect && e.keyCode === 9)) { // enter or tab
          this.insertItem()
          e.preventDefault()
          e.stopPropagation()
          return
        }
        if (e.keyCode === 27) { // esc
          this.closePanel()
          return
        }
      }
      if (e.keyCode === 8) {
        this.handleDelete(e)
      }
    },
    insertItem () {
      const { list, cur, atEnd } = this.atwho
      const { suffix, atItems, itemName } = this
      const el = this.$el.querySelector('input')
      const text = el.value.slice(0, atEnd)
      const { at, index } = getAtAndIndex(text, atItems)
      el.selectionStart = index + at.length
      el.focus() // textarea必须focus回来
      const curItem = list[cur]
      const t = itemName(curItem) + suffix
      this.insertText(`#${t}`, el)
      this.$emit('insert', curItem)
      this.handleInput()
    },
    openPanel (list, chunk, offset, at) {
      const fn = () => {
        let el = this.$el.querySelector('input')

        const atEnd = offset + at.length // 从@后第一位开始
        const rect = getCaretCoordinates(el, atEnd)
        this.atwho = {
          chunk,
          offset,
          list,
          atEnd,
          x: rect.left,
          y: rect.top - 4,
          cur: 0, // todo: 尽可能记录
        }
      }

      if (this.atwho) {
        fn()
      } else { // 焦点超出了显示区域 需要提供延时以移动指针 再计算位置
        setTimeout(fn, 10)
      }
    },
  },
}
</script>

<style scoped>
  .highlight {
    font-style: italic;
  }
</style>
